/* unplugin-vue-components disabled */import { render } from "./user-stats.vue?vue&type=template&id=45e24bcd&scoped=true"
import script from "./user-stats.vue?vue&type=script&lang=js"
export * from "./user-stats.vue?vue&type=script&lang=js"

import "./user-stats.vue?vue&type=style&index=0&id=45e24bcd&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45e24bcd"],['__file',"src/controls/user-stats.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "45e24bcd"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('45e24bcd', __exports__)) {
    api.reload('45e24bcd', __exports__)
  }
  
  module.hot.accept("./user-stats.vue?vue&type=template&id=45e24bcd&scoped=true", () => {
    api.rerender('45e24bcd', render)
  })

}


export default __exports__